import { render, staticRenderFns } from "./SmallFlow.vue?vue&type=template&id=871ec484&scoped=true&"
import script from "./SmallFlow.vue?vue&type=script&lang=js&"
export * from "./SmallFlow.vue?vue&type=script&lang=js&"
import style0 from "./SmallFlow.vue?vue&type=style&index=0&id=871ec484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871ec484",
  null
  
)

export default component.exports